module.exports = __webpack_public_path__ + "img/signout.5c26e624.svg";